

import locationEscalationManagerReducer from './LocationEscalationManagerReducer'
export { locationEscalationManagerReducer }

export * from './LocationEscalationManagerActions'



// WEBPACK FOOTER //
// ./src/store/location-escalation-manager/index.js